import React from "react";
import { useTranslation } from "react-i18next";
import { PageSelectionButton } from "../PageSelectionButton/PageSelectionButton";
import { Squash as Hamburger } from "hamburger-react";
import { DemoModalButton } from "../ModalButtons/DemoModalButton";
import { TrialModalButton } from "../ModalButtons/TrialModalButton";

export function PageSelection(props) {
    const { t } = useTranslation();

    const [isOpen, setOpen] = React.useState(false);

    const toggleMenu = () => {
        setOpen((current) => !current);
        const scrollStyle = isOpen ? "auto" : "hidden";
        document.body.style.overflow = scrollStyle;
    };

    return (
        <div className="w-full ml-12 md:ml-0 h-full flex items-center xl:hidden">
            <div className="w-full h-full bg-[#368E66] z-20 flex items-center justify-start">
                <Hamburger
                    color="white"
                    rounded
                    size={24}
                    toggled={isOpen}
                    toggle={toggleMenu}
                />
            </div>
            <div
                className={`absolute pb-2 top-24 bg-[#3A9E70] z-10 w-max transition-all ease-in-out select-none overflow-y-auto max-h-[90vh] ${
                    isOpen
                        ? "opacity-1 translate-y-[0]"
                        : "opacity-0 -translate-y-full"
                }`}
            >
                <PageSelectionButton
                    onClick={toggleMenu}
                    content={t("home")}
                    target=""
                    className="[&>a]:w-full"
                />
                <PageSelectionButton
                    onClick={toggleMenu}
                    content={t("guides")}
                    target="guides"
                    className="[&>a]:w-full"
                />
                <PageSelectionButton
                    onClick={toggleMenu}
                    content={t("manual")}
                    target="manual/introduction"
                    className="[&>a]:w-full"
                />
                <PageSelectionButton
                    onClick={toggleMenu}
                    content={t("manual-prerequisites")}
                    target="manual/prerequisites"
                    className="[&>a]:!pl-24 [&>a]:w-full"
                />
                <PageSelectionButton
                    onClick={toggleMenu}
                    content={t("manual-basics")}
                    target="manual/basics"
                    className="[&>a]:!pl-24 [&>a]:w-full"
                />
                <PageSelectionButton
                    onClick={toggleMenu}
                    content={t("manual-forest-management-planning")}
                    target="manual/forest-management-planning"
                    className="[&>a]:!pl-24 [&>a]:w-full"
                />
                <PageSelectionButton
                    onClick={toggleMenu}
                    content={t("manual-action-planning")}
                    target="manual/action-planning"
                    className="[&>a]:!pl-24 [&>a]:w-full"
                />
                <PageSelectionButton
                    onClick={toggleMenu}
                    content={t("manual-drone-operations")}
                    target="manual/drone-operations"
                    className="[&>a]:!pl-24 [&>a]:w-full"
                />
                <PageSelectionButton
                    onClick={toggleMenu}
                    content={t("manual-advanced")}
                    target="manual/advanced"
                    className="[&>a]:!pl-24 [&>a]:w-full"
                />
                <PageSelectionButton
                    onClick={toggleMenu}
                    content={t("api")}
                    target="api"
                    className="[&>a]:w-full"
                />
                <PageSelectionButton
                    onClick={toggleMenu}
                    content={t("faq")}
                    target="faq"
                    className="[&>a]:w-full"
                />
                <div className="w-full px-6 mb-2">
                    <div className="w-full h-0.5 bg-white opacity-20"></div>
                </div>
                <DemoModalButton className="!w-full !mt-6 !mx-6" />
                <TrialModalButton className="!w-full !m-6" />
            </div>
        </div>
    );
}
